import { CONTACT } from "@/lib/brand";
import { Phone, Mail, MapPin, Clock } from "lucide-react";

const embedUrl = `https://www.google.com/maps?q=${CONTACT.mapsEmbedQuery}&output=embed`;

export default function ContactSection() {
  return (
    <section
      data-testid="contact-section"
      id="contact"
      className="py-24 md:py-32 bg-white"
    >
      <div className="mx-auto max-w-6xl px-6 md:px-10 grid grid-cols-1 lg:grid-cols-2 gap-10 items-start">
        <div>
          <span className="inline-block text-xs tracking-[0.28em] uppercase font-semibold text-[#cb05a5]">
            Come Say Hi
          </span>
          <h2 className="mt-3 font-display font-black text-4xl sm:text-5xl text-slate-900 tracking-tight">
            Visit, call or write to us.
          </h2>

          <div className="mt-10 space-y-6">
            <Row
              icon={MapPin}
              title="Address"
              body={CONTACT.address}
              tint="#299fe0"
            />
            <Row
              icon={Phone}
              title="Phone"
              body={CONTACT.phone}
              href={`tel:${CONTACT.phoneDial}`}
              tint="#cb05a5"
            />
            <Row
              icon={Mail}
              title="Email"
              body={CONTACT.email}
              href={`mailto:${CONTACT.email}`}
              tint="#299fe0"
            />
            <Row
              icon={Clock}
              title="Business Hours"
              body={
                <>
                  {CONTACT.openDays} · {CONTACT.hoursOpen}
                  <br />
                  <span className="text-slate-500 text-sm">
                    Lunch break: {CONTACT.lunchBreak}
                  </span>
                </>
              }
              tint="#cb05a5"
            />
          </div>
        </div>

        <div className="rounded-3xl overflow-hidden sb-shadow-lg h-[520px] w-full">
          <iframe
            src={embedUrl}
            title="Sky Basket location"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
      </div>
    </section>
  );
}

function Row({ icon: Icon, title, body, href, tint }) {
  const inner = (
    <div className="flex items-start gap-4">
      <div
        className="w-11 h-11 shrink-0 rounded-2xl flex items-center justify-center text-white"
        style={{ background: tint }}
      >
        <Icon size={18} strokeWidth={2} />
      </div>
      <div>
        <div className="text-xs uppercase tracking-[0.25em] font-semibold text-slate-500">
          {title}
        </div>
        <div className="mt-1 text-slate-800 leading-relaxed">{body}</div>
      </div>
    </div>
  );
  return href ? (
    <a href={href} className="block hover:opacity-80 transition-opacity">
      {inner}
    </a>
  ) : (
    inner
  );
}
